// src/modulos/Cadastros/ProceduresPage.js

import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useFirestore from '../../hooks/useFirestore';
import usePagePermissions from '../../hooks/usePagePermissions';
import styles from './Registers.module.css';
import { FiPlus, FiX, FiEdit, FiTrash2 } from 'react-icons/fi';
import { FaClipboard, FaMoneyCheck, FaIndustry } from 'react-icons/fa';
import { IoMdSettings } from "react-icons/io";

// Common Components
import {
    PageHeader,
    SearchBar,
    FormModal,
    ConfirmModal,
    TableSkeleton,
    EmptyState,
    Pagination,
    Toast,
} from '../../components/common';

import useToast from '../../hooks/useToast';
import usePagination from '../../hooks/usePagination';

// --- 1. Constantes e Definicoes da Colecao ---
const PROCEDURES_COLLECTION = 'procedures';
const ITEMS_PER_PAGE = 10;

// Opcoes para os Selects (Dropdowns) - Mantidos como estaticos para reduzir leituras no Firebase
const COST_CENTER_OPTIONS = [
    { value: '', label: '- Selecione -' },
    { value: 'Administrativo', label: 'Administrativo' },
    { value: 'Ativo', label: 'Ativo' },
    { value: 'Comercial', label: 'Comercial' },
    { value: 'Comex', label: 'Comex' },
    { value: 'Fabrica', label: 'Fabrica' },
    { value: 'Fabrica e Comercio', label: 'Fabrica e Comercio' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Laboratorio', label: 'Laboratorio' },
    { value: 'Logistica', label: 'Logistica' },
    { value: 'Manutencao Fabrica', label: 'Manutencao Fabrica' },
    { value: 'Producao', label: 'Producao' },
    { value: 'Amostra', label: 'Amostra' },
    { value: 'RH', label: 'RH' },
    { value: 'Transportadora', label: 'Transportadora' },
];

const TRACKING_OPTIONS = [
    { value: '', label: '- Selecione -' },
    { value: 'Agendamento de coleta', label: 'Agendamento de coleta' },
    { value: 'Alteracao de anexo de arquivo', label: 'Alteracao de anexo de arquivo' },
    { value: 'Alteracao de configuracao de e-Commerce', label: 'Nenhum' },
    { value: 'Alteracao de remessa de pagamento', label: 'Alteracao de remessa de pagamento' },
    { value: 'Alteracao do contas a pagar', label: 'Alteracao do contas a pagar' },
    { value: 'Alteracao do contas a receber', label: 'Alteracao do contas a receber' },
    { value: 'Alteracao do NCM', label: 'Alteracao do NCM' },
    { value: 'Anotacao', label: 'Anotacao' },
    { value: 'Autorizacao de remessa de pagamento', label: 'autorizacao de remessa de pagamento' },
    { value: 'Baixado de acordo com retorno de remessa', label: 'Baixado de acordo com retorno de remessa' },
    { value: 'Carga do retorno da remessa de pagamento', label: 'Carga do retorno da remessa de pagamento' },
    { value: 'Carta de acompanhamento consultada', label: 'Carta de acompanhamento consultada' },
    { value: 'Conferencia cega efetuada', label: 'Conferencia cega efetuada' },
    { value: 'Conferencia de produtos para envase concluido', label: 'Conferencia de produtos para envase concluido' },
    { value: 'Contas a receber - envio e email de cobranca antecipada', label: 'Contas a receber - envio e email de cobranca antecipada' },
    { value: 'Contas a receber - envio e email de cobranca atrasada', label: 'Contas a receber - envio e email de cobranca atrasada' },
    { value: 'Criacao de carta de correcao eletronica', label: 'Criacao de carta de correcao eletronica' },
    { value: 'Criacao de formula iniciada', label: 'Criacao de formula iniciada' },
    { value: 'Criacao de remessa de pagamento', label: 'Criacao de remessa de pagamento' },
    { value: 'Criacao de impressao de carta de correcao', label: 'Criacao de impressao de carta de correcao' },
    { value: 'Email enviado', label: 'Email enviado' },
    { value: 'Embalagens conferidas envase liberado', label: 'Embalagens conferidas envase liberado' },
    { value: 'Envase iniciado', label: 'Envase iniciado' },
    { value: 'Envase terminado enviado para rotulagem', label: 'Envase terminado enviado para rotulagem' },
    { value: 'Enviado na remessa para o banco', label: 'Enviado na remessa para o banco' },
    { value: 'Exclusao de remessa de pagamento', label: 'Exclusao de remessa de pagamento' },
    { value: 'Exclusao do contas a receber pelo financeiro', label: 'Exclusao do contas a receber pelo financeiro' },
    { value: 'Falha no registro de boleto via API', label: 'Falha no registro de boleto via API' },
    { value: 'Faturamento - realizada alteracao na condicao de faturamento ', label: 'Faturamento - realizada alteracao na condicao de faturamento ' },
    { value: 'Fim da interrupcao da atividade', label: 'Fim da interrupcao da atividade' },
    { value: 'Finalizado o apontamento da atividade', label: 'Finalizado o apontamento da atividade' },
    { value: 'Financeiro - Contas a receber - confirmacao de baixa de boleto ', label: 'Financeiro - Contas a receber - confirmacao de baixa de boleto ' },
    { value: 'Financeiro - Contas a receber - solicitacao de baixa de boleto ', label: 'Financeiro - Contas a receber - solicitacao de baixa de boleto ' },
    { value: 'Formulacao criada. Projeto enviado da criacao para o desenvolvimento', label: 'Formulacao criada. Projeto enviado da criacao para o desenvolvimento' },
    { value: 'Geracao do arquivo de remessa de pagamento', label: 'Geracao do arquivo de remessa de pagamento' },
    { value: 'Geracao do arquivo de remessa de pagamento via VAN', label: 'Geracao do arquivo de remessa de pagamento via VAN' },
    { value: 'Gerado boleto no contas a receber', label: 'Gerado boleto no contas a receber' },
    { value: 'Gerado boleto no faturamento', label: 'Gerado boleto no faturamento' },
    { value: 'Impressao do boleto', label: 'Impressao do boleto' },
    { value: 'Impressao ordem de producao', label: 'Impressao ordem de producao' },
    { value: 'inclusao anexo de arquivo', label: 'inclusao anexo de arquivo' },
    { value: 'Inclusao da configuracao do e-commerce', label: 'Inclusao da configuracao do e-commerce' },
    { value: 'Inclusao da solicitacao de projeto', label: 'Inclusao da solicitacao de projeto' },
    { value: 'Inclusao de contas a receber do e-commerce', label: 'Inclusao de contas a receber do e-commerce' },
    { value: 'Inclusao do contas a receber manualmente', label: 'Inclusao do contas a receber manualmente' },
    { value: 'Inclusao do contas a receber na expedicao', label: 'Inclusao do contas a receber na expedicao' },
    { value: 'Inclusao do contas a receber no faturamento', label: 'Inclusao do contas a receber no faturamento' },
    { value: 'Inclusao de pedido de venda. Aguardando analise', label: 'Inclusao de pedido de venda. Aguardando analise' },
    { value: 'Inclusao de pedido de venda. Aguardando analise -Pedido gerado a partir de gestao de ruptura', label: 'Inclusao de pedido de venda. Aguardando analise -Pedido gerado a partir de gestao de ruptura' },
    { value: 'Inclusao de titulo na remessa de pagamento', label: 'Inclusao de titulo na remessa de pagamento' },
    { value: 'Inclusao do contas a pagar manual', label: 'Inclusao do contas a pagar manual' },
    { value: 'Inclusao do contas a pagar pelo financeiro - Lancamento de nota fiscal', label: 'Inclusao do contas a pagar pelo financeiro - Lancamento de nota fiscal' },
    { value: 'Inclusao do contas a pagar pelo lancamento de cheque via pedido de compra', label: 'Inclusao do contas a pagar pelo lancamento de cheque via pedido de compra' },
    { value: 'Inclusao do contas a pagar pelo recebeminto do contas a receber', label: 'Inclusao do contas a pagar pelo recebeminto do contas a receber' },
    { value: 'Inclusao do contas a pagar pelo recebeminto do pedido de compra', label: 'Inclusao do contas a pagar pelo recebeminto do pedido de compra' },
    { value: 'Inclusao do contas associado ao pedido de venda', label: 'Inclusao do contas associado ao pedido de venda' },
    { value: 'Inclusao do pedido de compra', label: 'Inclusao do pedido de compra' },
    { value: 'Iniciado o apontamento da atividade', label: 'Iniciado o apontamento da atividade' },
    { value: 'Inicio da interrupcao da atividade', label: 'Iniciado interrupcao da atividade' },
    { value: 'Item do pedido de compra aprovado com restricoes pelo controle de qualidade', label: 'Item do pedido de compra aprovado com restricoes pelo controle de qualidade' },
    { value: 'Item do pedido de compra aprovado controle de qualidade', label: 'Item do pedido de compra aprovado pelo controle de qualidade' },
    { value: 'Item do pedido de compra nao aprovado pelo controle de qualidade', label: 'Item do pedido de compra nao aprovado pelo controle de qualidade' },
    { value: 'Item do pedido de venda aprovado com restricoes pelo controle de qualidade', label: 'Item do pedido de venda aprovado com restricoes pelo controle de qualidade' },
    { value: 'Item do pedido de venda aprovado pelo controle de qualidade', label: 'Item do pedido de venda aprovado pelo controle de qualidade' },
    { value: 'Item do pedido de venda nao aprovado pelo controle de qualidade', label: 'Item do pedido de venda nao aprovado pelo controle de qualidade' },
    { value: 'Item do pedido de venda produzido. Enviado para controle de qualidade', label: 'Item do pedido de venda produzido. Enviado para controle de qualidade' },
    { value: 'item do pedido de venda terceirizado recebido', label: 'Item do pedido de venda terceirizado recebido' },
    { value: 'Lancamento de cheques - Alteracao de cheque ', label: 'Lancamento de cheques - Alteracao de cheque ' },
    { value: 'Lancamento de cheques - Inclusao de cheque', label: 'Lancamento de cheques - Inclusao de cheque' },
    { value: 'Liquidacao de titulo a partir de arquivo de retono bancario', label: 'Liquidacao de titulo a partir de arquivo de retono bancario' },
    { value: 'NF Cancelada', label: 'NF Cancelada' },
    { value: 'NF inserida manualmente', label: 'NF inserida manualmente' },
    { value: 'OP nao aprovada pelo controle de qualidade', label: 'OP nao aprovada pelo controle de qualidade' },
    { value: 'Orcamento - Alteracao do Orcamento', label: 'Orcamento - Alteracao do Orcamento' },
    { value: 'Orcamento - Inclusao do Orcamento', label: 'Orcamento - Inclusao do Orcamento' },
    { value: 'Orcamento Alterado', label: 'Orcamento Alterado' },
    { value: 'Orcamento Aprovado', label: 'Orcamento Aprovado' },
    { value: 'Orcamento Incluido, Aguardando aprovacao.', label: 'Orcamento Incluido, Aguardando aprovacao.' },
    { value: 'Orcamento Perdido', label: 'Orcamento Perdido' },
    { value: 'Ordem de Producao Incluida, aguardando Pesagem', label: 'Ordem de Producao Incluida, aguardando Pesagem' },
    { value: 'Ordem de Servico - Finalizacao Analise Tecnica', label: 'Ordem de Servico - Finalizacao Analise Tecnica' },
    { value: 'Ordem de Servico - Finalizacao Documentacao', label: 'Ordem de Servico - Finalizacao Documentacao' },
    { value: 'Ordem de Servico - Finalizacao Logistica e Recebimento', label: 'Ordem de Servico - Finalizacao Logistica e Recebimento' },
    { value: 'Ordem de Servico - Inicio Analise Tecnica', label: 'Ordem de Servico - Inicio Analise Tecnica' },
    { value: 'Ordem de Servico - Inicio Documentacao', label: 'Ordem de Servico - Inicio Documentacao' },
    { value: 'Ordem de Servico - Inicio Logistica e Recebimento', label: 'Ordem de Servico - Inicio Logistica e Recebimento' },
    { value: 'Ordem de Servico enviada para faturamento', label: 'Ordem de Servico enviada para faturamento' },
    { value: 'Parcela Excluida', label: 'Parcela Excluida' },
    { value: 'Pedido de compra ajustado para recebimento', label: 'Pedido de compra ajustado para recebimento' },
    { value: 'Pedido de Compra Aprovado', label: 'Pedido de Compra Aprovado' },
    { value: 'Pedido de Compra Aprovado Automaticamente', label: 'Pedido de Compra Aprovado Automaticamente' },
    { value: 'Pedido de Compra Enviado para Aprovacao', label: 'Pedido de Compra Enviado para Aprovacao' },
    { value: 'Pedido de compra gerado via Requisicao de compra.', label: 'Pedido de compra gerado via Requisicao de compra.' },
    { value: 'Pedido de compra recebido completo, enviado para controle de qualidade', label: 'Pedido de compra recebido completo, enviado para controle de qualidade' },
    { value: 'Pedido de Compra Recebido Integral', label: 'Pedido de Compra Recebido Integral' },
    { value: 'Pedido de Compra Recebido Parcial', label: 'Pedido de Compra Recebido Parcial' },
    { value: 'Pedido de compra recebido parcial, enviado para controle de qualidade', label: 'Pedido de compra recebido parcial, enviado para controle de qualidade' },
    { value: 'Pedido de Compra Retornado', label: 'Pedido de Compra Retornado' },
    { value: 'Pedido de venda - Alteracao - Comissao do pedido de venda alterado', label: 'Pedido de venda - Alteracao - Comissao do pedido de venda alterado' },
    { value: 'Pedido de Venda - alteracao de pedido em montagem de carga', label: 'Pedido de Venda - alteracao de pedido em montagem de carga' },
    { value: 'Pedido de Venda - Dias para entrega - Iniciado Contagem', label: 'Pedido de Venda - Dias para entrega - Iniciado Contagem' },
    { value: 'Pedido de Venda - Execucao do picking', label: 'Pedido de Venda - Execucao do picking' },
    { value: 'Pedido de Venda - Faturamento - NF Consultada', label: 'Pedido de Venda - Faturamento - NF Consultada' },
    { value: 'Pedido de Venda - Inclusao de pedido em montagem de carga', label: 'Pedido de Venda - Inclusao de pedido em montagem de carga' },
    { value: 'Pedido de Venda / Ordem de Producao Liberado para Expedicao', label: 'Pedido de Venda / Ordem de Producao Liberado para Expedicao' },
    { value: 'Pedido de Venda alterado para Gerar Pre-Faturamento', label: 'Pedido de Venda alterado para Gerar Pre-Faturamento' },
    { value: 'Pedido de Venda alterado para Nao Gerar Pre-Faturamento', label: 'Pedido de Venda alterado para Nao Gerar Pre-Faturamento' },
    { value: 'Pedido de Venda Aprovado, Enviado para Faturamento', label: 'Pedido de Venda Aprovado, Enviado para Faturamento' },
    { value: 'Pedido de Venda Aprovado, Enviado para Producao', label: 'Pedido de Venda Aprovado, Enviado para Producao' },
    { value: 'Pedido de Venda Aprovado, Enviado para Terceirizacao', label: 'Pedido de Venda Aprovado, Enviado para Terceirizacao' },
    { value: 'Pedido de Venda Aprovado, Faturamento Automatico.', label: 'Pedido de Venda Aprovado, Faturamento Automatico.' },
    { value: 'Pedido de Venda Assinado, enviado para aguardando liberacao.', label: 'Pedido de Venda Assinado, enviado para aguardando liberacao.' },
    { value: 'Pedido de Venda Cancelado', label: 'Pedido de Venda Cancelado' },
    { value: 'Pedido de Venda enviado para Aprovacao', label: 'Pedido de Venda enviado para Aprovacao' },
    { value: 'Pedido de Venda enviado para Faturamento', label: 'Pedido de Venda enviado para Faturamento' },
    { value: 'Pedido de Venda Expedido - Enviado para Faturamento', label: 'Pedido de Venda Expedido - Enviado para Faturamento' },
    { value: 'Pedido de Venda Faturado', label: 'Pedido de Venda Faturado' },
    { value: 'Pedido de Venda Faturado em Gestao de Ruptura', label: 'Pedido de Venda Faturado em Gestao de Ruptura' },
    { value: 'Pedido de Venda Faturamento (Baixa do Estoque)', label: 'Pedido de Venda Faturamento (Baixa do Estoque)' },
    { value: 'Pedido de Venda Faturamento (Parcela)', label: 'Pedido de Venda Faturamento (Parcela)' },
    { value: 'Pedido de Venda Liberado pelo Comercial / Expedicao', label: 'Pedido de Venda Liberado pelo Comercial / Expedicao' },
    { value: 'Pedido de Venda Liberado pelo Financeiro', label: 'Pedido de Venda Liberado pelo Financeiro' },
    { value: 'Pedido de Venda Produzido - Disponibilizado para Expedicao', label: 'Pedido de Venda Produzido - Disponibilizado para Expedicao' },
    { value: 'Pedido de Venda Retornado', label: 'Pedido de Venda Retornado' },
    { value: 'Pedido de Venda Retornado para Fase Inicial', label: 'Pedido de Venda Retornado para Fase Inicial' },
    { value: 'Pedido Faturado Parcialmente', label: 'Pedido Faturado Parcialmente' },
    { value: 'Pedido reaberto para faturamento parcial', label: 'Pedido reaberto para faturamento parcial' },
    { value: 'Pesagem concluida, Enviada para Producao', label: 'Pesagem concluida, Enviada para Producao' },
    { value: 'Producao - Alteracao de quantidade', label: 'Producao - Alteracao de quantidade' },
    { value: 'Producao - Motivo de Cancelamento', label: 'Producao - Motivo de Cancelamento' },
    { value: 'Producao Concluida, liberada para envase', label: 'Producao Concluida, liberada para envase' },
    { value: 'Projeto Aprovado pelo Financeiro', label: 'Projeto Aprovado pelo Financeiro' },
    { value: 'Projeto Aprovado pelo Marketing', label: 'Projeto Aprovado pelo Marketing' },
    { value: 'Projeto Aprovado, Enviado para Criacao', label: 'Projeto Aprovado, Enviado para Criacao' },
    { value: 'Projeto Aprovado, Enviado para Desenv.', label: 'Projeto Aprovado, Enviado para Desenv.' },
    { value: 'Projeto Desenvolvido', label: 'Projeto Desenvolvido' },
    { value: 'Projeto em Aprovacao', label: 'Projeto em Aprovacao' },
    { value: 'Projeto Excluido', label: 'Projeto Excluido' },
    { value: 'Projeto Reprovado', label: 'Projeto Reprovado' },
    { value: 'Projeto Retornado', label: 'Projeto Retornado' },
    { value: 'Proposta Comercial - Alteracao de Proposta', label: 'Proposta Comercial - Alteracao de Proposta' },
    { value: 'Proposta Comercial - Inclusao de Proposta', label: 'Proposta Comercial - Inclusao de Proposta' },
    { value: 'Re-gerado Boleto', label: 'Re-gerado Boleto' },
    { value: 'Registro de Boleto efetuado com sucesso: via API', label: 'Registro de Boleto efetuado com sucesso: via API' },
    { value: 'Registro de envio de Cobranca via e-mail', label: 'Registro de envio de Cobranca via e-mail' },
    { value: 'Registro de Reclamacao', label: 'Registro de Reclamacao' },
    { value: 'Retrabalho apontado na Ordem de Servico', label: 'Retrabalho apontado na Ordem de Servico' },
    { value: 'Rotulagem Finalizada. Ordem de Producao Concluida. Produto em estoque.', label: 'Rotulagem Finalizada. Ordem de Producao Concluida. Produto em estoque.' },
    { value: 'Rotulagem iniciada', label: 'Rotulagem iniciada' },
    { value: 'Rotulagem Parcial. Produto em estoque.', label: 'Rotulagem Parcial. Produto em estoque.' },
    { value: 'Saida de Veiculo', label: 'Saida de Veiculo' },
    { value: 'Simulacao de Importacao - Alteracao da Simulacao', label: 'Simulacao de Importacao - Alteracao da Simulacao' },
    { value: 'Simulacao de Importacao - Inclusao da Simulacao', label: 'Simulacao de Importacao - Inclusao da Simulacao' },
    { value: 'Situacao de transporte alterada para entregue.', label: 'Situacao de transporte alterada para entregue.' },
    { value: 'Solicitacao de Projeto enviado para Desenvolvimento', label: 'Solicitacao de Projeto enviado para Desenvolvimento' },
    { value: 'Titulo contem ocorrencias na remessa de pagamento, titulo liberado', label: 'Titulo contem ocorrencias na remessa de pagamento, titulo liberado' },
    { value: 'Titulo liberado da remessa de pagamento', label: 'Titulo liberado da remessa de pagamento' },
    { value: 'Titulo Removido do Arquivo de Remessa de Pagamento', label: 'Titulo Removido do Arquivo de Remessa de Pagamento' },
];

// Modelo padrao para um novo procedimento vazio
const DEFAULT_PROCEDURE_MODEL = {
    code: '',
    name: '',
    description: '',
    costCenter: '',
    tracking: '',
    setupCost: '',
    setupTime: '',
    internalHourCost: '',
    externalHourCost: '',
    capacityKg: '',
    lossPerBatchKg: '',
    minCapacity: '',
    minOperators: '',
    qtyOperators: '',
    isOperationProcedure: false,
    contabilizeAppointment: false,
    usedInPackaging: false,
};

// Funcao auxiliar para comparar objetos (deep comparison for numeric values)
const isEqualProcedureData = (current, original) => {
    if (!original) return false;

    const keys = Object.keys(DEFAULT_PROCEDURE_MODEL);
    for (const key of keys) {
        let currentValue = current[key];
        let originalValue = original[key];

        // Trata numeros como strings para comparacao
        if (typeof originalValue === 'number' && typeof currentValue === 'string') {
            originalValue = originalValue.toString();
        }
        if (typeof originalValue === 'string' && typeof currentValue === 'number') {
            currentValue = currentValue.toString();
        }

        if (currentValue !== originalValue) return false;
    }
    return true;
};

const ProceduresPage = () => {
    const { t } = useTranslation();
    const can = usePagePermissions('procedimentos');
    const { toasts, addToast, removeToast } = useToast();

    // --- Estados Principais ---
    const [editingItem, setEditingItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formStatus, setFormStatus] = useState({ message: '', type: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState({ isOpen: false, itemId: null, itemName: '' });
    const [closeConfirm, setCloseConfirm] = useState({ isOpen: false, hasChanges: false });

    // --- Estados para os Dados do Formulario ---
    const [procedureData, setProcedureData] = useState(DEFAULT_PROCEDURE_MODEL);

    // --- Hooks de Dados Principal (useFirestore) ---
    const {
        data: procedures,
        loading: mainLoading,
        addDocument,
        updateDocument,
        deleteDocument,
    } = useFirestore(PROCEDURES_COLLECTION, 'code');

    // --- Pagination ---
    const filteredProcedures = useMemo(() => {
        if (!procedures) return [];
        const lowerSearch = searchTerm.toLowerCase();
        return procedures.filter(item =>
            (item.name && item.name.toLowerCase().includes(lowerSearch)) ||
            (item.code && item.code.toLowerCase().includes(lowerSearch)) ||
            (item.description && item.description.toLowerCase().includes(lowerSearch))
        );
    }, [procedures, searchTerm]);

    const {
        currentPage,
        totalPages,
        currentItems: currentProcedures,
        goToPage,
        resetPage,
    } = usePagination(filteredProcedures, ITEMS_PER_PAGE);

    // Reset page when search changes
    useEffect(() => {
        resetPage();
    }, [searchTerm, resetPage]);

    // --- Geracao de Codigo Sequencial Autonomo ---
    const generateNextSequentialCode = useCallback(() => {
        const prefix = 'PROC';
        if (!procedures || procedures.length === 0) return `${prefix}001`;

        const matchingCodes = procedures
            .filter(item => item.code && item.code.startsWith(prefix))
            .map(item => parseInt(item.code.slice(prefix.length), 10))
            .filter(num => !isNaN(num));

        let nextNumber = 1;
        if (matchingCodes.length > 0) {
            nextNumber = Math.max(...matchingCodes) + 1;
        }
        return `${prefix}${nextNumber.toString().padStart(3, '0')}`;
    }, [procedures]);

    // Verifica se o formulario tem alteracoes nao salvas
    const hasUnsavedChanges = useCallback(() => {
        if (!isModalOpen) return false;

        if (editingItem) {
            const originalData = {
                ...editingItem,
                setupCost: editingItem.setupCost?.toString() || '',
                setupTime: editingItem.setupTime?.toString() || '',
                internalHourCost: editingItem.internalHourCost?.toString() || '',
                externalHourCost: editingItem.externalHourCost?.toString() || '',
                capacityKg: editingItem.capacityKg?.toString() || '',
                lossPerBatchKg: editingItem.lossPerBatchKg?.toString() || '',
                minCapacity: editingItem.minCapacity?.toString() || '',
                minOperators: editingItem.minOperators?.toString() || '',
                qtyOperators: editingItem.qtyOperators?.toString() || '',
                isOperationProcedure: !!editingItem.isOperationProcedure,
                contabilizeAppointment: !!editingItem.contabilizeAppointment,
                usedInPackaging: !!editingItem.usedInPackaging,
            };
            return !isEqualProcedureData(procedureData, originalData);
        } else {
            const defaultWithoutCode = { ...DEFAULT_PROCEDURE_MODEL, code: procedureData.code };
            return !isEqualProcedureData(procedureData, defaultWithoutCode);
        }
    }, [isModalOpen, editingItem, procedureData]);

    // --- Funcoes de Controle ---
    const resetForm = () => {
        setProcedureData(DEFAULT_PROCEDURE_MODEL);
        setEditingItem(null);
        setFormStatus({ message: '', type: '' });
        setIsSubmitting(false);
        setCloseConfirm({ isOpen: false, hasChanges: false });
    };

    const closeModal = () => {
        if (hasUnsavedChanges()) {
            setCloseConfirm({ isOpen: true, hasChanges: true });
            return;
        }
        setIsModalOpen(false);
        resetForm();
    };

    const handleNewClick = () => {
        if (!can.create) {
            addToast(t('pages.procedures.noPermissionCreate'), 'error');
            return;
        }
        resetForm();
        const nextCode = generateNextSequentialCode();
        setProcedureData(prev => ({ ...prev, code: nextCode }));
        setIsModalOpen(true);
    };

    const handleEditClick = (item) => {
        if (!can.edit) {
            addToast(t('pages.procedures.noPermissionEdit'), 'error');
            return;
        }
        resetForm();
        setEditingItem(item);

        setProcedureData({
            ...item,
            setupCost: item.setupCost?.toString() || '',
            setupTime: item.setupTime?.toString() || '',
            internalHourCost: item.internalHourCost?.toString() || '',
            externalHourCost: item.externalHourCost?.toString() || '',
            capacityKg: item.capacityKg?.toString() || '',
            lossPerBatchKg: item.lossPerBatchKg?.toString() || '',
            minCapacity: item.minCapacity?.toString() || '',
            minOperators: item.minOperators?.toString() || '',
            qtyOperators: item.qtyOperators?.toString() || '',
            isOperationProcedure: !!item.isOperationProcedure,
            contabilizeAppointment: !!item.contabilizeAppointment,
            usedInPackaging: !!item.usedInPackaging,
        });
        setIsModalOpen(true);
    };

    const handleDeleteClick = (itemId, itemName) => {
        if (!can.delete) {
            addToast(t('pages.procedures.noPermissionDelete'), 'error');
            return;
        }
        setDeleteConfirm({
            isOpen: true,
            itemId: itemId,
            itemName: itemName
        });
    };

    const confirmDelete = async () => {
        if (!deleteConfirm.itemId) return;

        try {
            const result = await deleteDocument(deleteConfirm.itemId);
            if (result.success) {
                addToast(t('pages.procedures.deleteSuccess'), 'success');
            } else {
                addToast(`${t('pages.procedures.deleteError')}: ${result.error}`, 'error');
            }
        } catch (error) {
            addToast(t('pages.procedures.unexpectedError'), 'error');
            console.error(error);
        } finally {
            setDeleteConfirm({ isOpen: false, itemId: null, itemName: '' });
        }
    };

    const cancelDelete = () => {
        setDeleteConfirm({ isOpen: false, itemId: null, itemName: '' });
    };

    const handleConfirmClose = () => {
        setCloseConfirm({ isOpen: false, hasChanges: false });
        setIsModalOpen(false);
        resetForm();
    };

    const cancelClose = () => {
        setCloseConfirm({ isOpen: false, hasChanges: false });
    };

    // Handler generico para inputs
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setProcedureData(prev => ({ ...prev, [name]: checked }));
        } else {
            setProcedureData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setProcedureData(prev => ({ ...prev, [name]: value }));
    };

    // Funcao para verificar se os dados realmente mudaram antes de salvar
    const hasDataChanged = useCallback(() => {
        if (!editingItem) {
            const hasAnyData = procedureData.name.trim() !== '' ||
                procedureData.description.trim() !== '' ||
                procedureData.costCenter !== '' ||
                procedureData.tracking !== '' ||
                procedureData.setupCost !== '' ||
                procedureData.setupTime !== '' ||
                procedureData.internalHourCost !== '' ||
                procedureData.externalHourCost !== '' ||
                procedureData.capacityKg !== '' ||
                procedureData.lossPerBatchKg !== '' ||
                procedureData.minCapacity !== '' ||
                procedureData.minOperators !== '' ||
                procedureData.qtyOperators !== '' ||
                procedureData.isOperationProcedure ||
                procedureData.contabilizeAppointment ||
                procedureData.usedInPackaging;
            return hasAnyData;
        }

        const originalData = {
            ...editingItem,
            setupCost: editingItem.setupCost?.toString() || '',
            setupTime: editingItem.setupTime?.toString() || '',
            internalHourCost: editingItem.internalHourCost?.toString() || '',
            externalHourCost: editingItem.externalHourCost?.toString() || '',
            capacityKg: editingItem.capacityKg?.toString() || '',
            lossPerBatchKg: editingItem.lossPerBatchKg?.toString() || '',
            minCapacity: editingItem.minCapacity?.toString() || '',
            minOperators: editingItem.minOperators?.toString() || '',
            qtyOperators: editingItem.qtyOperators?.toString() || '',
            isOperationProcedure: !!editingItem.isOperationProcedure,
            contabilizeAppointment: !!editingItem.contabilizeAppointment,
            usedInPackaging: !!editingItem.usedInPackaging,
        };
        return !isEqualProcedureData(procedureData, originalData);
    }, [editingItem, procedureData]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!editingItem && !can.create) {
            setFormStatus({ message: t('pages.procedures.noPermissionCreate'), type: 'error' });
            return;
        }
        if (editingItem && !can.edit) {
            setFormStatus({ message: t('pages.procedures.noPermissionEdit'), type: 'error' });
            return;
        }

        setFormStatus({ message: '', type: '' });

        if (isSubmitting) return;

        if (!procedureData.name.trim()) {
            setFormStatus({ message: t('pages.procedures.form.nameRequired'), type: 'error' });
            return;
        }

        if (!procedureData.code.trim()) {
            setFormStatus({ message: t('pages.procedures.form.codeRequired'), type: 'error' });
            return;
        }

        if (!hasDataChanged()) {
            setFormStatus({ message: t('pages.procedures.noChangesDetected'), type: 'info' });
            setIsModalOpen(false);
            resetForm();
            return;
        }

        setIsSubmitting(true);

        const dataToSave = {
            ...procedureData,
            name: procedureData.name.trim(),
            description: procedureData.description?.trim() || '',
            setupCost: parseFloat(procedureData.setupCost) || 0,
            setupTime: parseInt(procedureData.setupTime, 10) || 0,
            internalHourCost: parseFloat(procedureData.internalHourCost) || 0,
            externalHourCost: parseFloat(procedureData.externalHourCost) || 0,
            capacityKg: parseFloat(procedureData.capacityKg) || 0,
            lossPerBatchKg: parseFloat(procedureData.lossPerBatchKg) || 0,
            minCapacity: parseFloat(procedureData.minCapacity) || 0,
            minOperators: parseInt(procedureData.minOperators, 10) || 0,
            qtyOperators: parseInt(procedureData.qtyOperators, 10) || 0,
            updatedAt: new Date(),
        };

        try {
            let result;
            if (editingItem) {
                result = await updateDocument(editingItem.id, dataToSave);
                if (result.success) {
                    addToast(t('pages.procedures.updateSuccess'), 'success');
                    setIsModalOpen(false);
                    resetForm();
                } else {
                    setFormStatus({ message: `${t('pages.procedures.updateError')}: ${result.error}`, type: 'error' });
                    addToast(`${t('pages.procedures.updateError')}: ${result.error}`, 'error');
                }
            } else {
                dataToSave.createdAt = new Date();
                result = await addDocument(dataToSave);
                if (result.success) {
                    addToast(t('pages.procedures.createSuccess'), 'success');
                    setIsModalOpen(false);
                    resetForm();
                } else {
                    setFormStatus({ message: `${t('pages.procedures.createError')}: ${result.error}`, type: 'error' });
                    addToast(`${t('pages.procedures.createError')}: ${result.error}`, 'error');
                }
            }
        } catch (error) {
            setFormStatus({ message: t('pages.procedures.unexpectedError'), type: 'error' });
            addToast(t('pages.procedures.unexpectedError'), 'error');
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSearch = useCallback((term) => {
        setSearchTerm(term);
    }, []);

    // --- 7. Renderizacao do Modal ---
    const renderFormModalContent = () => {
        const isFormDisabled = !can.create && !can.edit;

        return (
            <>
                <div className={styles.formSection}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.sectionIcon}><FaClipboard /></div>
                        <h3 className={styles.sectionTitle}>{t('pages.procedures.form.mainData')}</h3>
                        <span className={styles.sectionBadge}>{t('common.required')}</span>
                    </div>
                    <div className={styles.formGrid}>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.code')} <span className={styles.required}>*</span></label>
                            <input
                                type="text"
                                name="code"
                                value={procedureData.code}
                                disabled
                                className={styles.input}
                            />
                            <small className={styles.fieldHint}>{t('pages.procedures.form.codeHint')}</small>
                        </div>
                        <div className={styles.inputGroup} style={{ gridColumn: 'span 2' }}>
                            <label>{t('pages.procedures.form.name')} <span className={styles.required}>*</span></label>
                            <input
                                type="text"
                                name="name"
                                value={procedureData.name}
                                onChange={handleChange}
                                required
                                className={styles.input}
                                placeholder={t('pages.procedures.form.namePlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup} style={{ gridColumn: 'span 3' }}>
                            <label>{t('pages.procedures.form.description')}</label>
                            <textarea
                                name="description"
                                value={procedureData.description}
                                onChange={handleChange}
                                className={styles.textarea}
                                placeholder={t('pages.procedures.form.descriptionPlaceholder')}
                                rows={3}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.formSection}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.sectionIcon}><FaMoneyCheck /></div>
                        <h3 className={styles.sectionTitle}>{t('pages.procedures.form.classificationAndCosts')}</h3>
                    </div>
                    <div className={styles.formGrid}>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.costCenter')}</label>
                            <select
                                name="costCenter"
                                value={procedureData.costCenter}
                                onChange={handleSelectChange}
                                className={styles.select}
                                disabled={isSubmitting || isFormDisabled}
                            >
                                {COST_CENTER_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.tracking')}</label>
                            <select
                                name="tracking"
                                value={procedureData.tracking}
                                onChange={handleSelectChange}
                                className={styles.select}
                                disabled={isSubmitting || isFormDisabled}
                            >
                                {TRACKING_OPTIONS.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className={styles.formGrid}>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.setupCost')}</label>
                            <input
                                type="number"
                                step="0.01"
                                name="setupCost"
                                value={procedureData.setupCost}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.setupCostPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.setupTime')}</label>
                            <input
                                type="number"
                                name="setupTime"
                                value={procedureData.setupTime}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.setupTimePlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.internalHourCost')}</label>
                            <input
                                type="number"
                                step="0.01"
                                name="internalHourCost"
                                value={procedureData.internalHourCost}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.internalHourCostPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.externalHourCost')}</label>
                            <input
                                type="number"
                                step="0.01"
                                name="externalHourCost"
                                value={procedureData.externalHourCost}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.externalHourCostPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.formSection}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.sectionIcon}><FaIndustry /></div>
                        <h3 className={styles.sectionTitle}>{t('pages.procedures.form.capacityAndOperators')}</h3>
                    </div>
                    <div className={styles.formGrid}>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.capacityKg')}</label>
                            <input
                                type="number"
                                step="0.001"
                                name="capacityKg"
                                value={procedureData.capacityKg}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.capacityKgPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.lossPerBatchKg')}</label>
                            <input
                                type="number"
                                step="0.001"
                                name="lossPerBatchKg"
                                value={procedureData.lossPerBatchKg}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.lossPerBatchKgPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.minCapacity')}</label>
                            <input
                                type="number"
                                step="0.001"
                                name="minCapacity"
                                value={procedureData.minCapacity}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.minCapacityPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.minOperators')}</label>
                            <input
                                type="number"
                                name="minOperators"
                                value={procedureData.minOperators}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.minOperatorsPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label>{t('pages.procedures.form.qtyOperators')}</label>
                            <input
                                type="number"
                                name="qtyOperators"
                                value={procedureData.qtyOperators}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder={t('pages.procedures.form.qtyOperatorsPlaceholder')}
                                disabled={isSubmitting || isFormDisabled}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.formSection}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.sectionIcon}><IoMdSettings /></div>
                        <h3 className={styles.sectionTitle}>{t('pages.procedures.form.additionalSettings')}</h3>
                    </div>
                    <div className={styles.checkboxGrid}>
                        <label className={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                name="isOperationProcedure"
                                checked={procedureData.isOperationProcedure}
                                onChange={handleChange}
                                disabled={isSubmitting || isFormDisabled}
                            />
                            <span className={styles.checkboxText}>{t('pages.procedures.form.isOperationProcedure')}</span>
                        </label>
                        <label className={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                name="contabilizeAppointment"
                                checked={procedureData.contabilizeAppointment}
                                onChange={handleChange}
                                disabled={isSubmitting || isFormDisabled}
                            />
                            <span className={styles.checkboxText}>{t('pages.procedures.form.contabilizeAppointment')}</span>
                        </label>
                        <label className={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                name="usedInPackaging"
                                checked={procedureData.usedInPackaging}
                                onChange={handleChange}
                                disabled={isSubmitting || isFormDisabled}
                            />
                            <span className={styles.checkboxText}>{t('pages.procedures.form.usedInPackaging')}</span>
                        </label>
                    </div>
                </div>
            </>
        );
    };

    // --- Table Render ---
    const renderTable = () => {
        if (mainLoading) {
            return <TableSkeleton columns={6} rows={ITEMS_PER_PAGE} />;
        }

        if (currentProcedures.length === 0) {
            return (
                <div className={styles.tableContainer}>
                    <EmptyState
                        icon="⚙️"
                        title={searchTerm ? t('pages.procedures.table.emptySearch') : t('pages.procedures.table.empty')}
                        message={searchTerm ? t('pages.procedures.search.noResults') : t('pages.procedures.table.emptyMessage')}
                        actionText={can.create ? t('pages.procedures.newProcedure') : undefined}
                        onAction={can.create ? handleNewClick : undefined}
                    />
                </div>
            );
        }

        return (
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th style={{ width: '80px' }}>{t('pages.procedures.table.code')}</th>
                        <th>{t('pages.procedures.table.name')}</th>
                        <th>{t('pages.procedures.table.costCenter')}</th>
                        <th>{t('pages.procedures.table.setupCost')}</th>
                        <th>{t('pages.procedures.table.capacity')}</th>
                        <th style={{ width: '150px' }}>{t('common.actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {currentProcedures.map(item => (
                        <tr key={item.id}>
                            <td><strong>{item.code}</strong></td>
                            <td>{item.name}</td>
                            <td>
                                {COST_CENTER_OPTIONS.find(opt => opt.value === item.costCenter)?.label || '-'}
                            </td>
                            <td>
                                {item.setupCost ? `R$ ${item.setupCost.toFixed(2)}` : '-'}
                            </td>
                            <td>
                                {item.capacityKg ? `${item.capacityKg.toFixed(3)} KG` : '-'}
                            </td>
                            <td>
                                <div className={styles.actionsContainer}>
                                    {can.edit && (
                                        <button onClick={() => handleEditClick(item)} className={styles.actionButton}>
                                            <FiEdit />
                                        </button>
                                    )}
                                    {can.delete && (
                                        <button onClick={() => handleDeleteClick(item.id, item.name)} className={`${styles.actionButton} ${styles.deleteButton}`}>
                                            <FiTrash2 />
                                        </button>
                                    )}
                                    {!can.edit && !can.delete && (
                                        <span className={styles.textMuted}>{t('common.noActionsAvailable')}</span>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div className={styles.pageContainer}>
            {/* Toast Notifications */}
            {toasts.length > 0 && (
                <div className={styles.toastContainer}>
                    {toasts.map(toast => (
                        <Toast
                            key={toast.id}
                            message={toast.message}
                            type={toast.type}
                            onClose={() => removeToast(toast.id)}
                        />
                    ))}
                </div>
            )}

            {/* Form Modal */}
            <FormModal
                isOpen={isModalOpen}
                onClose={closeModal}
                onSubmit={handleFormSubmit}
                title={editingItem ? t('pages.procedures.editProcedure') : t('pages.procedures.newProcedure')}
                subtitle={editingItem ? `${t('pages.procedures.editingLabel')}: ${editingItem.name} (${editingItem.code})` : undefined}
                isLoading={isSubmitting}
                error={formStatus.type === 'error' ? formStatus.message : ''}
                success={formStatus.type === 'success' ? formStatus.message : ''}
                submitText={editingItem ? t('common.saveChanges') : t('common.create')}
                maxWidth="860px"
            >
                {renderFormModalContent()}
            </FormModal>

            {/* Delete Confirmation Modal */}
            <ConfirmModal
                isOpen={deleteConfirm.isOpen}
                onClose={cancelDelete}
                onConfirm={confirmDelete}
                title={t('pages.procedures.confirmAction')}
                message={t('pages.procedures.deleteConfirm', { name: deleteConfirm.itemName })}
                confirmText={t('common.confirm')}
                cancelText={t('common.cancel')}
                isLoading={isSubmitting}
                danger
            />

            {/* Close Confirmation Modal */}
            <ConfirmModal
                isOpen={closeConfirm.isOpen}
                onClose={cancelClose}
                onConfirm={handleConfirmClose}
                title={t('pages.procedures.confirmAction')}
                message={t('pages.procedures.closeConfirm')}
                confirmText={t('common.confirm')}
                cancelText={t('common.cancel')}
                isLoading={false}
            />

            {/* Page Header */}
            <PageHeader
                title={t('pages.procedures.title')}
                actionText={can.create ? t('pages.procedures.newProcedure') : undefined}
                onAction={handleNewClick}
                disabled={mainLoading}
                showAction={can.create}
            />

            {/* Search Bar */}
            <SearchBar
                placeholder={t('pages.procedures.search.placeholder')}
                onSearch={handleSearch}
                disabled={mainLoading}
                debounceDelay={300}
                initialValue={searchTerm}
            />

            {/* Table */}
            <div className={styles.tableContainer}>
                {renderTable()}
            </div>

            {/* Pagination */}
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={filteredProcedures.length}
                onPageChange={goToPage}
                disabled={mainLoading}
                itemsLabel={t('pages.procedures.table.items')}
            />
        </div>
    );
};

export default ProceduresPage;